export default {
    apiKey: "AIzaSyBnLFeSxDVDy7w97sniBy-E3LCtVRrEBDM",
    authDomain: "fishninja-spa.firebaseapp.com",
    databaseURL: "https://fishninja-spa.firebaseio.com",
    projectId: "fishninja-spa",
    storageBucket: "fishninja-spa.appspot.com",
    messagingSenderId: "291402527367",
    appId: "1:291402527367:web:5ece7278ba2ff5939b3e22",
    measurementId: "G-BREE87R59E"
  };